export default __webpack_public_path__ + "images/W9.0a8ed9e.png";